import { gql } from '@apollo/client'

export const SEARCH_FANTASY_LEAGUES = gql`
  query SearchFantasyLeagues($name: String!, $limit: Int, $offset: Int) {
    searchFantasyLeagues(name: $name, limit: $limit, offset: $offset) {
      leagues {
        id
        name
        isPublic
        participantsCount
        image
        updatedAt
        creator {
          id
          fullName
          picture
        }
        competition {
          id
          officialChannels {
            id
            name
            image
            updatedAt
          }
        }
      }
      totalCount
      offset
      limit
    }
  }
`
